import { Link } from "react-router-dom";
import { CmlMark } from "./Brand";
import { CONTACT, NAV_LINKS } from "../data/content";

const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-neon/10 bg-panel/30 py-14">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
            <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
                <div className="max-w-sm">
                    <CmlMark />
                    <p className="mt-5 text-sm leading-relaxed text-slate-500">
                        Clean My Life — nettoyage automobile à domicile, detailing automobile
                        et nettoyage intérieur voiture à Cannes & alentours. Lavage
                        automobile premium, directement chez vous sur la Côte d'Azur.
                    </p>
                </div>
                <nav className="flex flex-col gap-2.5" data-testid="footer-nav">
                    <p className="mb-1 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-neon/80">
                        Navigation
                    </p>
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.hash}
                            href={`/${l.hash}`}
                            className="text-sm text-slate-400 transition-colors hover:text-neon"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <div className="flex flex-col gap-2.5">
                    <p className="mb-1 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-neon/80">
                        Contact
                    </p>
                    <a href={CONTACT.phoneHref} className="text-sm text-slate-400 transition-colors hover:text-neon">
                        {CONTACT.phoneDisplay}
                    </a>
                    <a href={`mailto:${CONTACT.email}`} className="text-sm text-slate-400 transition-colors hover:text-neon">
                        {CONTACT.email}
                    </a>
                    <Link to="/reservation" data-testid="footer-reserve-link" className="text-sm font-semibold text-neon hover:underline">
                        Réserver en ligne →
                    </Link>
                </div>
            </div>
            <div className="mt-12 border-t border-white/5 pt-6 text-center text-xs text-slate-600">
                © {new Date().getFullYear()} Clean My Life — Cannes & alentours · On nettoie, vous brillez.
            </div>
        </div>
    </footer>
);

export default Footer;
